import { render, staticRenderFns } from "./edit_or_detail.vue?vue&type=template&id=8ded7ffa&scoped=true"
import script from "./edit_or_detail.vue?vue&type=script&lang=js"
export * from "./edit_or_detail.vue?vue&type=script&lang=js"
import style0 from "./edit_or_detail.vue?vue&type=style&index=0&id=8ded7ffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ded7ffa",
  null
  
)

export default component.exports